export default __webpack_public_path__ + "static/media/SOAL NO 5. TUTORIAL KEYWORDS.33edfbc9.mp4";